import {createFileRoute} from '@tanstack/react-router';
import {DemoLoginPage} from 'pages/login/DemoLoginPage';

export const Route = createFileRoute('/demo')({
  component: DemoLoginPage,
});
